import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-add-subgroup',
  templateUrl: './add-subgroup.component.html',
  styleUrls: ['./add-subgroup.component.css']
})
export class AddSubgroupComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  routeID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  company = [];
  users = [];
  form: FormGroup;
  messageErr;
  wellfareAreas = [];
  btnText = "Lisää toimipiste";
  isLoading = false;
  title = "Lisää toimipiste";

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {

     }

  ngOnInit(): void {
    //this.getBusinessDetails();
    if(this.routeID){
      this.title = "Muokkaa toimipistettä";
      this.btnText = "Tallenna"
    }
    this.fetchWelfareAreas();
    this.form = this.fb.group({
      businessName: ['', [
        Validators.required,
      ]],
      address: "",
      zip: "",
      city: ['', [
        Validators.required,
      ]],
      description: '',

    }); 

    if(this.routeID){
      this.fetchSubGroupDetails();
    }
  }

  get address() { return this.form.get('address') };
  get businessName() { return this.form.get('businessName') };
  get zip() { return this.form.get('zip') };
  get city() { return this.form.get('city') };
  get description() { return this.form.get('description') };


  onSubmit(){

    if(this.routeID){
      this.editSubGroup();
    }
    else{
      this.addSubGroup();
    }
  }



  addSubGroup(){

      
    console.log('Submitting');
    if (!this.form.valid) {
      return;
    }

    var selectedwellfareArea;
    var elm = (<HTMLSelectElement>document.getElementById("wellfareArea")).value;
    for (let i = 0; i < this.wellfareAreas.length; i++) {
      const area = this.wellfareAreas[i];

      if(area.id == elm){
        selectedwellfareArea = area;
        break;
      }
      
    }

    //Check if selected wellfare area is valid
    if(selectedwellfareArea == null){
      alert('Valitse toimialue');
      return;
    }

    this.isLoading = true;



    const request = {
      businessName: this.form.get('businessName').value,
      address: this.form.get('address').value,
      zip: this.form.get('zip').value,
      city: this.form.get('city').value,
      description: this.form.get('description').value,
      wellfareArea: selectedwellfareArea,
    }



       this.http.post(environment.SUBGROUP, request, this.httpOptions).subscribe(
        (res: any) => {
          console.log(res);
          this.isLoading = false;
          if (res.status == 200) {
            this.router.navigate(['/'+this.businessID+'/company-details'])
          } 
          
          else {
            if(res.status == 202){
              alert('Virhe osoitetta haettaessa. Ole hyvä ja tarkista osoitteesi.');
              return;
            }
            else{
              alert('Virhe lisätessä alaryhmää. Ole hyvä ja yritä uudelleen')
            }
          }
        }, (err: any) => {

          console.log("Error while login :: ", err);
        }
      )

    } 

    fetchWelfareAreas() {
      this.http.get(environment.PARAMS_WELLFAREAREAS, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            console.log(res.message);
            this.wellfareAreas = res.message['wellfare-areas'];
            console.log(this.wellfareAreas)
  
          }
          else {
            var anElm = document.getElementById('notadded');
            anElm.style.display="block";
            console.log('ei ole kyseistä käyttäjää')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
    }

    fetchSubGroupDetails() {



      this.http.get(environment.SUBGROUP + '/' + this.routeID, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {

            console.log(res.message);
            this.form.get('businessName').setValue(res.message.businessName);
            this.form.get('address').setValue(res.message.address);
            this.form.get('zip').setValue(res.message.zip);
            this.form.get('city').setValue(res.message.city);
            this.form.get('description').setValue(res.message.description);

            setTimeout(() => {
              (<HTMLSelectElement>document.getElementById("wellfareArea")).value = res.message.wellfareArea.id;
            }, 300);
          }
          else {
            var anElm = document.getElementById('notadded');
            anElm.style.display="block";
            console.log('ei ole kyseistä käyttäjää')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
    }

    editSubGroup(){
        
        console.log('Submitting');
        if (!this.form.valid) {
          return;
        }
    
        var selectedwellfareArea;
        var elm = (<HTMLSelectElement>document.getElementById("wellfareArea")).value;
        for (let i = 0; i < this.wellfareAreas.length; i++) {
          const area = this.wellfareAreas[i];
    
          if(area.id == elm){
            selectedwellfareArea = area;
            break;
          }
          
        }
    
        //Check if selected wellfare area is valid
        if(selectedwellfareArea == null){
          alert('Valitse toimialue');
          return;
        }

        const request = {
          businessName: this.form.get('businessName').value,
          address: this.form.get('address').value,
          zip: this.form.get('zip').value,
          city: this.form.get('city').value,
          description: this.form.get('description').value,
          wellfareArea: selectedwellfareArea,

        }

        console.log(request);

        this.isLoading = true;

        this.http.put(environment.SUBGROUP + '/' + this.routeID, request, this.httpOptions).subscribe(
          (res: any) => {
            this.isLoading = false;
            if (res.status == 200) {

              this.router.navigate(['/'+this.businessID+'/company-details'])
            } 
            
            else {
              if(res.status == 202){
                alert('Virhe osoitetta haettaessa. Ole hyvä ja tarkista osoitteesi.');
                return;
              }
              else{
                alert('Virhe lisätessä alaryhmää. Ole hyvä ja yritä uudelleen')
              }
            }
          }
        )
    }

    goBack(){
      window.history.back();
  }

}
